import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import ConnectivityGroup from "../../../../groups/ConnectivityGroup";

class MetricLivePricingNotAvailableCount extends MetricBase {
    constructor() {
        super({
            field: "metric_livePricingNotAvailableCount",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.livePricingNotAvailableCount.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.livePricingNotAvailableCount.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.livePricingNotAvailableCount.tooltip"),
            group: new ConnectivityGroup(),
        });
    }
}

export default MetricLivePricingNotAvailableCount;
